import { useEffect, useState } from "react";
import { useAccounts } from "@/hooks/useAccounts";
import { useSampleDataStatus } from "@/hooks/useSampleData";
import { resolveAccountKind } from "@/lib/accountKind";
import { MockCleanupDialog } from "./MockCleanupDialog";

/**
 * Watcher mounted once in the global Layout.
 * Opens the cleanup dialog when:
 *   - the user has sample data (is_mock account exists)
 *   - AND has at least one non-sample account
 *   - AND has not previously chosen "never_ask" or "delete"
 */
export function MockCleanupWatcher() {
  const { data: accounts } = useAccounts();
  const { data: status } = useSampleDataStatus();
  const [open, setOpen] = useState(false);

  useEffect(() => {
    if (!accounts || !status) return;
    if (!status.hasSample) return;
    if (status.cleanupChoice === "never_ask" || status.cleanupChoice === "delete") return;
    if (status.cleanupChoice === "keep") return; // Already decided to keep — don't re-prompt

    const hasNonSample = accounts.some((a) => resolveAccountKind(a) !== "sample");
    if (hasNonSample) {
      setOpen(true);
    }
  }, [accounts, status]);

  if (!status?.hasSample) return null;

  return <MockCleanupDialog open={open} onOpenChange={setOpen} />;
}
